<div class="side-inner">
    <button title="close form" class="close-popup-button close-button modal-close" (click)="goBack()">close</button>
    <lib-ng-quote-new (formDirtyChange)="formDirtyChange($event)" [licenseType]="licenseType" [productCode]="productCode" [action]="action" id="quoteContainer" (closeForm)="goBack()"></lib-ng-quote-new>
</div>
